var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "svg",
      {
        attrs: {
          height: "50px",
          width: "50px",
          version: "1.1",
          id: "Layer_1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          viewBox: "0 0 512 512",
          "xml:space": "preserve",
        },
      },
      [
        _c("g", [
          _c("path", {
            staticStyle: { fill: "#ffe7e5" },
            attrs: {
              d: "M414.857,140.8c-29.645,0-53.76-24.115-53.76-53.76s24.115-53.76,53.76-53.76\n\t\tc29.645,0,53.76,24.115,53.76,53.76S444.493,140.8,414.857,140.8z",
            },
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: { fill: "#ffe7e5" },
            attrs: {
              d: "M97.417,140.8c-29.645,0-53.76-24.115-53.76-53.76s24.115-53.76,53.76-53.76\n\t\ts53.76,24.115,53.76,53.76S127.061,140.8,97.417,140.8z",
            },
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: { fill: "#ffe7e5" },
            attrs: {
              d: "M256.137,140.8c-35.294,0-64-28.706-64-64s28.706-64,64-64s64,28.706,64,64\n\t\tS291.422,140.8,256.137,140.8z",
            },
          }),
        ]),
        _vm._v(" "),
        _c("polygon", {
          staticStyle: { fill: "#919cb0" },
          attrs: {
            points:
              "218.709,499.2 207.514,358.4 163.994,358.4 194.253,192 318.02,192 348.271,358.4\n\t304.751,358.4 293.555,499.2 ",
          },
        }),
        _vm._v(" "),
        _c("g", [
          _c("polygon", {
            staticStyle: { fill: "#bdc4d0" },
            attrs: {
              points:
                "67.157,423.253 58.274,311.654 23.782,311.654 47.761,179.772 145.86,179.772\n\t\t169.839,311.654 135.347,311.654 126.473,423.253 \t",
            },
          }),
          _vm._v(" "),
          _c("polygon", {
            staticStyle: { fill: "#bdc4d0" },
            attrs: {
              points:
                "385.553,423.253 376.678,311.654 342.187,311.654 366.165,179.772 464.256,179.772\n\t\t488.243,311.654 453.743,311.654 444.868,423.253 \t",
            },
          }),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("path", {
            staticStyle: { fill: "#573a32" },
            attrs: {
              d: "M97.417,148.48c33.929,0,61.44-27.511,61.44-61.44S131.345,25.6,97.417,25.6\n\t\ts-61.44,27.511-61.44,61.44S63.479,148.48,97.417,148.48z M97.417,46.08c22.588,0,40.96,18.372,40.96,40.96S120.004,128,97.417,128\n\t\ts-40.96-18.372-40.96-40.96S74.829,46.08,97.417,46.08z",
            },
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: { fill: "#573a32" },
            attrs: {
              d: "M414.566,148.48c33.929,0,61.44-27.511,61.44-61.44s-27.503-61.44-61.44-61.44\n\t\ts-61.44,27.511-61.44,61.44S380.638,148.48,414.566,148.48z M414.566,46.08c22.588,0,40.96,18.372,40.96,40.96\n\t\tS437.154,128,414.566,128s-40.96-18.372-40.96-40.96S391.987,46.08,414.566,46.08z",
            },
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: { fill: "#573a32" },
            attrs: {
              d: "M496.162,298.411l-20.48-112.64c-1.775-9.737-10.249-16.819-20.147-16.819h-81.92\n\t\tc-9.899,0-18.381,7.083-20.147,16.819l-11.785,64.802l-9.156-50.355c-2.219-12.169-12.826-21.018-25.19-21.018h-102.4\n\t\tc-12.373,0-22.972,8.849-25.19,21.018l-9.293,51.132l-11.921-65.579c-1.775-9.737-10.249-16.819-20.147-16.819h-81.92\n\t\tc-9.899,0-18.381,7.083-20.147,16.819l-20.48,112.64c-1.084,5.973,0.538,12.126,4.429,16.785c3.874,4.668,9.634,7.364,15.71,7.364\n\t\th13.082l7.458,93.781c0.853,10.65,9.737,18.859,20.42,18.859h40.96c10.684,0,19.567-8.209,20.412-18.859l7.458-93.781H157.5\n\t\tl-3.354,18.466c-1.357,7.467,0.666,15.155,5.53,20.983c4.864,5.828,12.066,9.199,19.652,9.199h16.358l9.327,117.231\n\t\tc1.058,13.303,12.169,23.56,25.523,23.56h51.2c13.355,0,24.465-10.257,25.515-23.569l9.327-117.231h16.358\n\t\tc7.595,0,14.788-3.371,19.652-9.199c4.864-5.828,6.886-13.517,5.53-20.983l-3.354-18.458h11.452l7.458,93.781\n\t\tc0.845,10.65,9.728,18.859,20.412,18.859h40.96c10.684,0,19.567-8.209,20.412-18.859l7.467-93.781h13.082\n\t\tc6.076,0,11.836-2.697,15.727-7.356S497.246,304.393,496.162,298.411z M126.857,302.08l-8.96,112.64h-40.96l-8.96-112.64h-32\n\t\tl20.48-112.64h30.72v61.44c0,5.658,4.582,10.24,10.24,10.24c5.658,0,10.24-4.582,10.24-10.24v-61.44h30.72l20.48,112.64H126.857z\n\t\t M292.932,345.6l-11.196,140.8h-51.2l-11.196-140.8h-40.004l25.6-140.8h38.4v76.8c0,7.074,5.726,12.8,12.8,12.8\n\t\tc7.074,0,12.8-5.726,12.8-12.8v-76.8h38.4l25.6,140.8H292.932z M444.006,302.08l-8.96,112.64h-40.96l-8.96-112.64h-32l20.48-112.64\n\t\th30.72v61.44c0,5.658,4.582,10.24,10.24,10.24s10.24-4.582,10.24-10.24v-61.44h30.72l20.48,112.64H444.006z",
            },
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: { fill: "#573a32" },
            attrs: {
              d: "M256.137,153.6c42.419,0,76.8-34.381,76.8-76.8S298.556,0,256.137,0s-76.8,34.381-76.8,76.8\n\t\tS213.717,153.6,256.137,153.6z M256.137,25.6c28.228,0,51.2,22.972,51.2,51.2s-22.972,51.2-51.2,51.2s-51.2-22.972-51.2-51.2\n\t\tS227.9,25.6,256.137,25.6z",
            },
          }),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }